// Ignore lint error here since this is where we define the
// suggested replacement hook.
// eslint-disable-next-line no-restricted-imports
import { useEnabled } from 'react-enable';

import { FeatureFlags } from 'types';

export const useFeature = (feature: keyof FeatureFlags) => useEnabled(feature);
